import React, { useState, useRef, useEffect } from "react";
import { cardsConfigRVO } from "../Utils/constants";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";
import TitleQuoteForm from "./titleQuoteForm";
import HideInput from "./hide-input";
import limpiarIcon from "../Resources/svg/gl_delete_filled.svg";
import DetailItem from "./detailItem";
import { DualRing } from "react-loading-io";
import AlertNotifications from "./FormElements/AlertNotifications";
import { useDispatch } from "react-redux";
import { alert, stateAlert } from "../Store/simulate/actions";
import { ModalSiscoForm }from './ModalSiscoUpdate';
import moment from "moment";
import Table from "./FormElements/Table";
import {
  updateShowSisco
} from "../Store/secureInvestmentIncome/actions";
import TableRequestRVO from "./tableRequestRVO";
import Pagination from "./FormElements/pagination";
import SpinnerTable from "./SpinnerTable";
import CardTablaRequestRVO from "./FormElements/CardTablaRequestRVO";
import { API } from "aws-amplify";
import { CSVLink, CSVDownload } from "react-csv";
import { downloadXLSX } from "../Utils/utils";

const ModalSISCO = ({ open, close, id_product }) => {
  const dispatch = useDispatch();

  const [isLoading, setisLoading] = useState(false);
  const [processedRequests, setProcessedRequests] = useState(false);
  const [tableRequest, setTableRequest] = useState([]);
  const [selectedSisco, setSelectedSisco] = useState();
  const [ stateSiscoModalForm, setSiscoModalForm ] = useState(false)

  const getRequests = async () => {
    setisLoading(true);
      try {
        const response = await API.get(
          "api-vitalicias",
          "/solicitud/fechaSisco"
        );
        if(response){
          if(response.payload.data){
            response.payload.data.forEach((item) => item.active = false );
            setTableRequest([...response.payload.data])
          }
        }
      } catch (err) {
      }
      setisLoading(false);
  };

  useEffect(() => {
    getRequests()
  }, [])

  const handleClose = () => {
    dispatch(updateShowSisco(false))
  }

  const handleCloseSiscoModal = () => {
    setSiscoModalForm(!stateSiscoModalForm);
  }

    const setAlert = (type, title, message) => {
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type,
          title,
          message,
        })
      );
  
      setTimeout(() => {
        dispatch(stateAlert(false));
      }, 2500);
    };

  const handleExecuteForm = (type) => {
    switch(type) {
      case 'INSERT':
        cleanData()
        setSiscoModalForm(true);
        break
      case 'UPDATE':
        setSiscoModalForm(true);
        break
    }
  }

    const handleOnChange = (index) => {
      const resetTable = [...tableRequest]
      resetTable.forEach((item) => item.active = false);
      resetTable[index].active = !resetTable[index].active;
      setTableRequest(resetTable)
      setSelectedSisco(resetTable[index]);
    };
  
    const cleanData = () => {
      const resetTable = [...tableRequest]
      resetTable.forEach((item) => item.active = false);
      setTableRequest(resetTable)
      setSelectedSisco(null);
    }

    const handleSubmitSisco = (values) => {
      setSiscoModalForm(false);
      sendSisco(values, (selectedSisco ? 'UPDATE' : 'CREATE'))

    }

    const sendSisco = async (formValue, type) => {

      const request = {
        body: {payload: {
          event: type,
          id: "fechasSisco",
          data: {
            contractName: formValue.contractName,
            endDate: String(moment(formValue.endDate, "DD/MM/YYYY").endOf("day").unix()),
            startDate: String(moment(formValue.startDate, "DD/MM/YYYY").startOf("day").unix())
          }
        }},
      };
      setisLoading(true);
        try {
          const response = await API.post(
            "api-vitalicias",
            "/solicitud/fechaSisco",
            request
          );
          if(response){
            cleanData()
             setAlert(
            "success",
            "¡Registro Sisco procesadas!",
            "Los registros Siscos se han procesado correctamente."
          );
          getRequests()
          }
        } catch (err) {
        }
        setisLoading(false);
    };

  return (
    <div className={`modalFormRVO  ${open ? "is-open" : ""}`}>
      <div className="modalFormRVO__container">
        <div className="modalFormRVO__container__button" onClick={handleClose}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        {!processedRequests && (
          <div className="configHome configHome-sisco">
            <TitleQuoteForm
              title={"Seguro Previsional"}
              subtitle={"Detalle de contratos Seguro Previsional"}
            />
                 <div className="sectionTable-sisco">
                      <div className="sectionTable-sisco__actionButtons">
                          <>
                            <button
                              className="btn is-small" onClick={() => handleExecuteForm('INSERT')}>Insertar
                            </button>
                            <button disabled={!selectedSisco} className="btn is-small" onClick={() => handleExecuteForm('UPDATE')} >
                              Editar
                            </button>
                            <button disabled={!selectedSisco} onClick={() => sendSisco(selectedSisco, 'DELETE')} className="btn is-small">
                              Eliminar
                            </button>
                          </>
                      </div>
                    </div>
            <div className="configHome__container-sisco">
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Nombre de contrato</th>
                    <th width="20%">Fecha Inicio</th>
                    <th width="20%">Fecha Termino</th>
                  </tr>
                </thead>
                <tbody>
                  {tableRequest &&
                    tableRequest.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div className="column-checkbox">
                  <label>
                    <input
                      type="checkbox"
                      name={`checkbox_${index}`}
                      className="filled-in"
                      checked={item.active}
                      onChange={(e) => handleOnChange(index)}
                    />
                    <span></span>
                  </label>
                </div>
                        </td>
                        <td>{item.contractName}</td>
                        <td>{moment.unix(item.startDate).format('DD/MM/YYYY')}</td>
                        <td>{moment.unix(item.endDate).format('DD/MM/YYYY')}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}

      </div>

      {isLoading && (
        <div className="loading-field">
          <DualRing size={50} />
        </div>
      )}
      <ModalSiscoForm onSubmit={(values)=> handleSubmitSisco(values)} selectedSisco={selectedSisco} open={stateSiscoModalForm} close={handleCloseSiscoModal} />
      <AlertNotifications />
    </div>
  );
};

export default ModalSISCO;
